module.exports = __webpack_public_path__ + "html/schwacke-api.template.html";